import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://codepilot.engineer'; // update when you have a real domain
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
const SITE_NAME = 'CodePilot Engineer';

interface SEOProps {
  title?: string;
  description?: string;
  /** Absolute URL to the OG image. Defaults to the banner. */
  image?: string;
  /** Canonical URL for this page */
  url?: string;
  /** 'website' | 'article' — defaults to 'website' */
  type?: string;
  /** Prevent indexing (e.g. auth-callback, dashboard) */
  noIndex?: boolean;
}

export function SEO({
  title,
  description = 'CodePilot Engineer — AI-powered codebase intelligence. Ask questions about your architecture, understand ownership, and navigate large codebases with ease.',
  image = DEFAULT_OG_IMAGE,
  url,
  type = 'website',
  noIndex = false,
}: SEOProps) {
  const pageTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Engineering Intelligence Platform`;

  return (
    <Helmet>
      {/* ── Primary ── */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {url && <link rel="canonical" href={url} />}

      {/* ── Open Graph ── */}
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:title"       content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={image} />
      <meta property="og:image:width"  content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type"        content={type} />
      {url && <meta property="og:url" content={url} />}

      {/* ── Twitter / X Card ── */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={image} />

      {/* ── Theme color (browser chrome) ── */}
      <meta name="theme-color" content="#6366f1" />
    </Helmet>
  );
}
